<template>
  <div id="app">
    <title>{{ESTABELECIMENTO.nome}}</title>
    <link rel="icon" :href="ESTABELECIMENTO.logo" />
    <div class="row box-load" v-show="loading">
      <Loading />
    </div>
    <div v-show="!loading">
      <header>
        <div class="navbar-fixed">
          <nav>
            <div class="display-nav nav-wrapper black">
              <router-link
                to="#"
                data-target="slide-out"
                v-if="client != false"
                class="show-on-large sidenav-trigger hide-on-med-and-down left"
              >
                <span class="white-text name">
                  <div class="nome-menu">
                    Bem-vindo &nbsp;
                    <b>{{client.nome}}</b>
                    <i class="material-icons arrow">arrow_drop_down</i>
                  </div>
                </span>
              </router-link>
              <div v-if="client != false" class="div-saldo hide-on-med-and-down">
                <b>Saldo de Pontos :</b>
                {{client.saldo}} {{' '+ ESTABELECIMENTO.moeda ? ESTABELECIMENTO.moeda : ' pontos'}}
              </div>
              <router-link
                v-if="client == false || innerWidth < 801"
                :to="'/'+$route.params.slug"
                class="brand-logo"
              >
                <img class="logo-nav" :src="ESTABELECIMENTO.logo" />
              </router-link>
              <router-link
                to="#"
                data-target="slide"
                class="sidenav-trigger show-on-medium-and-down"
              >
                <i class="material-icons">menu</i>
              </router-link>
              <ul id="nav-mobile" class="nav-ul right hide-on-med-and-down">
                <li>
                  <router-link :to="'/'+this.$route.params.slug+'/'">Home</router-link>
                </li>
                <li>
                  <router-link :to="'/'+this.$route.params.slug+'/como-funciona'">Como Funciona</router-link>
                </li>
                <li>
                  <router-link :to="'/'+this.$route.params.slug+'/contato'">Contato</router-link>
                </li>
                <li>
                  <router-link :to="'/'+this.$route.params.slug+'/regulamento'">Regulamento</router-link>
                </li>
                <li>
                  <router-link
                    v-show="client == false"
                    :to="'/'+this.$route.params.slug+'/login'"
                  >Login</router-link>
                </li>
                <li>
                  <router-link
                    v-show="client == false"
                    :to="'/'+this.$route.params.slug+'/cadastro'"
                    v-if="configs.cadastro_permitido"
                  >Cadastre-se</router-link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
        <ul id="slide-out" class="sidenav sidenav-close">
          <li>
            <div class="div-sidenav user-view" v-show="client != false">
              <a class="display-link" href="#name">
                <img
                  v-if="client.foto != null && client.foto != ''"
                  class="circle"
                  :src="client.foto"
                />
                <img v-else class="circle" src="./assets/img/no_avatar.jpg" />
                <i
                  data-position="bottom"
                  data-tooltip="Atualizar pontuação."
                  class="icon-style tooltipped material-icons"
                  @click="updateBalance()"
                >refresh</i>
              </a>

              <span class="black-text name">
                <p>
                  <b>{{client.nome}}</b>
                </p>
                <p>{{client.saldo + ' ' + ESTABELECIMENTO.moeda}}</p>
              </span>
              <span class="black-text email">{{client.email}}</span>
            </div>
          </li>
          <li>
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/meus-dados'"
            >Meus dados</router-link>
          </li>
          <li>
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/alterar-senha'"
            >Alterar senha</router-link>
          </li>
          <li>
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/meus-pontos'"
            >Meus pontos</router-link>
          </li>
          <li>
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/meus-resgates'"
            >Meus Resgates</router-link>
          </li>
          <li>
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/meus-presentes'"
            >Meus presentes</router-link>
          </li>
          <li v-if="ESTABELECIMENTO.habilitar_codigo_pontuavel">
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/codigo-pontuavel'"
            >Inserir código</router-link>
          </li>
          <li v-if="ESTABELECIMENTO.cliente_pode_indicar">
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/indique'"
            >Indique amigos</router-link>
          </li>
          <li v-if="ESTABELECIMENTO.pode_compartilhar">
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/compartilhe'"
            >Compartilhe e ganhe</router-link>
          </li>
          <li>
            <router-link to="#" v-show="client != false" @click.native="logout()">Sair</router-link>
          </li>
        </ul>
        <ul id="slide" class="sidenav sidenav-close">
          <li>
             <div class="div-sidenav user-view" v-show="client != false">
              <a class="display-link" href="#name">
                <img
                  v-if="client.foto != null && client.foto != ''"
                  class="circle"
                  :src="client.foto"
                />
                <img v-else class="circle" src="./assets/img/no_avatar.jpg" />
                <i
                  data-position="bottom"
                  data-tooltip="Atualizar pontuação."
                  class="icon-style tooltipped material-icons"
                  @click="updateBalance()"
                >refresh</i>
              </a>

              <span class="black-text name">
                <p>
                  <b>{{client.nome}}</b>
                </p>
                <p>{{client.saldo + ' ' + ESTABELECIMENTO.moeda}}</p>
              </span>
              <span class="black-text email">{{client.email}}</span>
            </div>
          </li>
          <li>
            <router-link :to="'/'+this.$route.params.slug+'/'">Home</router-link>
          </li>
          <li>
            <router-link :to="'/'+this.$route.params.slug+'/como-funciona'">Como Funciona</router-link>
          </li>
          <li>
            <router-link :to="'/'+this.$route.params.slug+'/contato'">Contato</router-link>
          </li>
          <li>
            <router-link :to="'/'+this.$route.params.slug+'/regulamento'">Regulamento</router-link>
          </li>
          <li>
            <router-link v-show="client == false" :to="'/'+this.$route.params.slug+'/login'">Login</router-link>
          </li>
          <li>
            <router-link
              v-show="client == false"
              :to="'/'+this.$route.params.slug+'/cadastro'"
              v-if="configs.cadastro_permitido"
            >Cadastre-se</router-link>
          </li>

          <li>
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/meus-dados'"
            >Meus dados</router-link>
          </li>
          <li>
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/alterar-senha'"
            >Alterar senha</router-link>
          </li>
          <li>
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/meus-pontos'"
            >Meus pontos</router-link>
          </li>
          <li>
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/meus-resgates'"
            >Meus Resgates</router-link>
          </li>
          <li>
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/meus-presentes'"
            >Meus presentes</router-link>
          </li>
          <li v-if="ESTABELECIMENTO.habilitar_codigo_pontuavel">
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/codigo-pontuavel'"
            >Inserir código</router-link>
          </li>
          <li v-if="ESTABELECIMENTO.cliente_pode_indicar">
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/indique'"
            >Indique amigos</router-link>
          </li>
          <li v-if="ESTABELECIMENTO.pode_compartilhar">
            <router-link
              v-show="client != false"
              :to="'/'+this.$route.params.slug+'/compartilhe'"
            >Compartilhe e ganhe</router-link>
          </li>
          <li>
            <router-link to="#" v-show="client != false" @click.native="logout()">Sair</router-link>
          </li>
        </ul>
      </header>
      <main>
        <div class="minHeight row">
          <router-view />
        </div>
        <FaixaApp
          v-if="ESTABELECIMENTO.app_habilitado || (ESTABELECIMENTO.url_ios!= null && ESTABELECIMENTO.url_android!=null)"
          class="FaixaApp-style"
        ></FaixaApp>
      </main>
      <footer class="page-footer black">
        <!-- <div class="alinhamento">
          <img class="logo-footer" :src="ESTABELECIMENTO.logo" />
          <div class="container">
            <div class="row">
              <div class="col l3 m6 s12">
                <ul>
                  <li>
                    <router-link
                      class="grey-text text-lighten-3"
                      :to="'/'+this.$route.params.slug+'/'"
                    >Home</router-link>
                  </li>
                </ul>
              </div>
              <div class="col l3 m6 s12">
                <ul>
                  <li>
                    <router-link
                      class="grey-text text-lighten-3"
                      :to="'/'+this.$route.params.slug+'/como-funciona'"
                    >Como Funciona</router-link>
                  </li>
                  <li>
                    <router-link
                      class="grey-text text-lighten-3"
                      :to="'/'+this.$route.params.slug+'/regulamento'"
                    >Regulamento</router-link>
                  </li>
                </ul>
              </div>
              <div class="col l3 m6 s12">
                <ul>
                  <li>
                    <a class="grey-text text-lighten-3">Contato:</a>
                  </li>
                  <li>
                    <a class="grey-text text-lighten-3">{{ESTABELECIMENTO.telefone}}</a>
                  </li>
                </ul>
              </div>
              <div class="col l3 m6 s12">
                <ul>
                  <li>
                    <router-link
                      v-show="client == false"
                      class="grey-text text-lighten-3"
                      :to="'/'+this.$route.params.slug+'/login'"
                    >Login</router-link>
                  </li>
                  <li>
                    <router-link
                      v-show="client == false"
                      class="grey-text text-lighten-3"
                      :to="'/'+this.$route.params.slug+'/cadastro'"
                      v-if="'/'+this.$route.params.slug+'configs.cadastro_permitido'"
                    >Cadastre-se</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>-->
        <div class="footer-copyright">
          <div class="footer-text container">
            <a
              class="white-text"
              target="_blank"
              href="http://www.donuz.com.br/site"
            >© {{(new Date()).getFullYear()}} Donuz</a>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<style scoped>
.box-load {
  height: 90vh;
}
.display-nav {
  display: flex;
}
.display-nav router-link {
  color: #fff;
}
.div-saldo b {
  margin-right: 5px;
}
.logo-nav {
  margin: auto 20px;
  max-height: 56px;
}
.nav-ul {
  margin-left: auto;
}
.div-sidenav {
  padding: 16px 16px 0;
}
.display-link {
  display: flex;
}
.icon-style {
  margin: 2px 5px auto auto;
}
.FaixaApp-style {
  margin-bottom: -20px;
}
.footer-text {
  text-align: center;
}
</style>
  
<style>
html {
  scroll-behavior: smooth;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
body {
  color: #666;
}
.title {
  text-align: center;
}
.nav ul a:hover {
  text-decoration: unset !important;
}

.nome-menu {
  border-right: 1px solid white;
  margin-right: 10px;
  padding-right: 10px;
  display: inline-flex;
}
input {
  color: #666;
}
select {
  color: #666;
}
.img-responsive {
  max-width: 100%;
  height: auto;
}
img {
  max-width: 100%;
  height: auto;
}
#nav-mobile li:hover {
  background-color: darkblue;
  color: #fff;
  text-decoration: none;
}
body {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

nav li a:hover {
  color: #fff;
  text-decoration: unset;
}

main {
  flex: 1 0 auto;
}
footer {
  position: relative;
  top: 100%;
  bottom: 0;
}
.alinhamento {
  display: flex;
}
.logo-footer {
  max-width: 75px;
  height: auto;
  margin: auto;
}
@media (max-width: 992px) {
  .logo-footer {
    display: none;
  }
}
footer li a {
  font-size: 20px;
}
.minHeight {
  min-height: calc(100vh - 463px);
}
</style>
<script>
// @ is an alias to /src
import { Donuz } from "@/donuz-js/Donuz";
import { config } from "chai";
import FaixaApp from "@/components/FaixaApp.vue";
import Loading from "@/components/Loading.vue";

export default {
  name: "app",
  components: {
    FaixaApp,
    Loading
  },
  data() {
    return {
      client: false,
      configs: {},
      loading: true
    };
  },
  mounted() {
    localStorage.setItem("atualizacao", "false");

    document.addEventListener("DOMContentLoaded", function() {
      var elems = document.querySelectorAll(".tooltipped");
      var instances = M.Tooltip.init(elems);
    });
  },
  async created() {
    M.AutoInit();
    this.configs = await Donuz.settings.getSettings(
      null,
      this.ESTABELECIMENTO.id
    );
    this.configs = this.configs.configuracoes;

    document.getElementsByTagName(
      "style"
    )[1].innerText = this.ESTABELECIMENTO.css;

    eval(this.ESTABELECIMENTO.js);

    var elems = document.querySelectorAll(".sidenav");
    M.Sidenav.init(elems, {});
    var dropdowns = document.querySelectorAll(".dropdown-trigger");
    M.Dropdown.init(dropdowns, {});

    if (sessionStorage.getItem(btoa("cliente")) != null) {
      this.client = JSON.parse(atob(sessionStorage.getItem(btoa("cliente"))));

      this.updateBalance();
    }
    this.loading = false;
  },
  computed: {
    innerWidth() {
      return window.innerWidth;
    }
  },
  methods: {
    logout: async function() {
      this.client = false;
      let resp = await Donuz.customer.logout(
        this.client.id_cliente != undefined
          ? this.client.id_cliente
          : this.client.id,
        sessionStorage.getItem(btoa("tokenCliente"))
      );
      sessionStorage.clear();
      location.href = "/" + this.$route.params.slug;
    },
    updateBalance: async function() {
      let result = await Donuz.balance.getCustomerBalance(
        sessionStorage.getItem(btoa("tokenCliente")),
        this.ESTABELECIMENTO.id
      );
      if (result.status == 200) {
        this.client.saldo = result.saldo;
        sessionStorage.setItem(
          btoa("cliente"),
          btoa(JSON.stringify(this.client))
        );
      }
    }
  }
};
</script>
